import React from "react";
import get from "lodash/get";
import uniq from "lodash/uniq";
import debounce from "lodash/debounce";
import { connect } from "react-redux";
import moment from "moment";
import find from "lodash/find";
import {
  Alert,
  Layout,
  Input,
  Table,
  Select,
  Checkbox,
  Icon,
  DatePicker,
  Button,
  message,
  Tooltip,
  Switch,
} from "antd";

import classes from "./FinanceGeneratedEvents.css";
import { withNamespaces } from "react-i18next";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getUsersLight,
  getGeneratedEventsRequest,
  getSettingsSitesRequest,
  setGeneratedEventsItemsRequest,
  updateGeneratedEventsRequest,
  deleteGeneratedEventsRequest,
  clearCacheGeneratedEventsRequest,
  getFinanceEventsList,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getUserTimezone,
  getUserShortTimezone,
  getFinanceInvoiceGeneratedEventUpdatePermission,
  getFinanceInvoiceGeneratedEventDeletePermission,
} from "../../reducers/user/selectors";
const { RangePicker } = DatePicker;

const routes = require("../../routes.json");

const { Content } = Layout;
const { Option } = Select;

class FinanceGeneratedEvents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      generatedEvents: [],
      generatedEventItem: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      users: [],
      filter: null,
      order: "asc",
      currentPage: 1,
      filterDateRange: [null, null],
      total: 1,
      pageSize: 25,
      eventsSelected: {},
      sortedInfo: {},
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      confirmAction: null,
      checkedItems: [],
      shiftDown: false,
      isFilterApprove: false,
      isClearingCache: false,
      eventList: [],
    };
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: true,
      });
    }
  };

  handleKeyUp = (event) => {
    if (event.keyCode === 16) {
      this.setState({
        shiftDown: false,
      });
    }
  };

  async componentDidMount() {
    this.onFilterApply();
    this.getFinanceEventList();

    try {
      const { data: users } = await getUsersLight();

      this.setState({ users });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }
    try {
      const { data: sites } = await getSettingsSitesRequest();

      this.setState({ sites });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }

    document.addEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keyup", this.handleKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.removeEventListener("keyup", this.handleKeyUp);
  }

  getFinanceEventList = async () => {
    const { data } = await getFinanceEventsList();
    this.setState({
      eventList: data,
    });
  };

  onFilterApply = async () => {
    this.setState(
      {
        filterBy: null,
        filterValue: null,
        currentPage: 1,
        eventsSelected: {},
      },
      this.getGeneratedEvents
    );
  };

  getGeneratedEvents = debounce(
    async (page = this.state.currentPage, per_page = this.state.pageSize) => {
      this.setState({
        errorMessage: null,
        isLoading: true,
        responseMessage: null,
      });

      try {
        const { data } = await getGeneratedEventsRequest({
          page,
          per_page,
          order_direction: this.state.order,
          order_column: get(this.state, "sortedInfo.columnKey"),
          filter_by: this.state.filtersBy,
          filter_value: this.state.filtersValue,
          start_date: this.state.filterDateRange[0]
            ? this.state.filterDateRange[0].toISOString()
            : undefined,
          end_date: this.state.filterDateRange[0]
            ? this.state.filterDateRange[1].toISOString()
            : undefined,
          filter_approve: this.state.isFilterApprove || undefined,
        });

        if (Array.isArray(data.data)) {
          this.setState({
            checkedItems: [],
          });

          this.setState({
            generatedEvents: data.data,
            total: data.total_pages * per_page,
            currentPage: page,
          });
        } else {
          this.setState({
            generatedEvents: [data],
            total: 1 * per_page,
            currentPage: page,
          });
        }
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        this.setState({
          generatedEvents: [],
          errorMessage: get(e, "response.data.error", "Error"),
        });
      }

      this.setState({ isLoading: false });
    },
    500
  );

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getGeneratedEvents(pagination.current, pagination.pageSize)
    );
  };

  handleFilterChange = (value) => {
    this.setState(() => {
      return { filtersBy: [value], filtersValue: [], currentPage: 1 };
    }, this.getGeneratedEvents);
  };

  clearFilters = () => {
    this.setState(
      { filtersBy: [], filtersValue: [], filterDateRange: [null, null], currentPage: 1 },
      this.getGeneratedEvents
    );
  };

  onChangeGeneratedEventStatusFilter = (value) => {
    this.setState((state) => {
      const filtersValue = [...state.filtersValue];
      filtersValue[0] = value;

      return { filtersValue, currentPage: 1 };
    }, this.getGeneratedEvents);
  };

  onChangeGeneratedEventTextFilter = (e) => {
    const value = e.target.value;
    this.setState((state) => {
      const filtersValue = [];
      filtersValue[0] = value;

      return { filtersValue, currentPage: 1 };
    }, this.getGeneratedEvents);
  };

  onDateRangeChange = (val) => {
    this.setState({ filterDateRange: val, currentPage: 1 }, this.getGeneratedEvents);
  };

  sentToInvoice = async () => {
    try {
      await setGeneratedEventsItemsRequest(this.state.checkedItems);
      message.success(this.props.i18n.t("Success"));
      this.setState({
        checkedItems: [],
        currentPage: 1,
      }, this.getGeneratedEvents);
    } catch (e) {
      message.error(get(e, "response.data.error", "Error"));
    }
  };

  onSwitchStatus = (event_status, item) => async () => {
    try {
      if (event_status === "enabled") {
        await updateGeneratedEventsRequest({ ...item, event_status });
      } else {
        await deleteGeneratedEventsRequest({ ...item, event_status });
      }
      message.success(this.props.i18n.t("Saved"));
      this.getGeneratedEvents();
    } catch (e) {
      message.error(get(e, "response.data.error", "Error"));
    }
  };

  clearCache = async () => {
    this.setState({
      isClearingCache: true,
    });
    try {
      await clearCacheGeneratedEventsRequest();
      this.onFilterApply();
    } catch (e) {
      console.log(e);
    } finally {
      this.setState({
        isClearingCache: false,
      });
    }
  };

  deleteGeneratedEventsRequest = async (item) => {
    try {
      await deleteGeneratedEventsRequest({ ...item });
      message.success(this.props.i18n.t("Deleted"));
      this.getGeneratedEvents();
    } catch (e) {
      message.error("Error");
    }
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      generatedEvents,
      currentPage,
      total,
      pageSize,
      sortedInfo,
      filtersValue,
      checkedItems,
      shiftDown,
      filterDateRange,
      sites,
      filtersBy,
      isFilterApprove,
      isClearingCache,
      eventList,
    } = this.state;

    let columns = [
      {
        dataIndex: "checkbox",
        key: "checkbox",
        title: () =>
          generatedEvents.length > 0 &&
          !this.state.isFilterApprove && (
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  this.setState(({ checkedItems }) => ({
                    checkedItems: uniq([
                      ...generatedEvents.filter((generatedEventItem) => generatedEventItem.event_status === "enabled").reduce(
                        (result, item) => [...result, item],
                        []
                      ),
                    ]),
                  }));
                } else {
                  this.setState(({ checkedItems }) => ({
                    checkedItems: [],
                  }));
                }
              }}
              indeterminate={
                checkedItems.length > 0 &&
                checkedItems.length !== generatedEvents.filter((generatedEventItem) => generatedEventItem.event_status === "enabled").length
              }
              checked={checkedItems.length === generatedEvents.filter((generatedEventItem) => generatedEventItem.event_status === "enabled").length}
            />
          ),
        render: (val, generatedEventItem, index) => (
          <div>
            {!this.state.isFilterApprove &&
              generatedEventItem.event_status === "enabled" && (
                <Checkbox
                  onChange={(e) => {
                    if (checkedItems.length && shiftDown) {
                      const lastCheckedItemIndex = generatedEvents.findIndex(
                        (item) =>
                          item.id === checkedItems[checkedItems.length - 1].id
                      );

                      let newItems = [];

                      if (lastCheckedItemIndex < index) {
                        newItems = generatedEvents.reduce(
                          (result, item, itemIndex) => {
                            return itemIndex > lastCheckedItemIndex &&
                              itemIndex <= index
                              ? [...result, item]
                              : result;
                          },
                          []
                        );
                      } else {
                        newItems = generatedEvents.reduce(
                          (result, item, itemIndex) => {
                            return itemIndex < lastCheckedItemIndex &&
                              itemIndex >= index
                              ? [...result, item]
                              : result;
                          },
                          []
                        );
                      }

                      this.setState(({ checkedItems }) => ({
                        checkedItems: uniq([...checkedItems, ...newItems]),
                      }));
                    } else {
                      this.setState(({ checkedItems }) => ({
                        checkedItems: e.target.checked
                          ? uniq([...checkedItems, generatedEventItem])
                          : uniq(
                              checkedItems.filter(
                                (item) => item.id !== generatedEventItem.id
                              )
                            ),
                      }));
                    }
                  }}
                  checked={
                    checkedItems.findIndex(
                      (item) => item.id === generatedEventItem.id
                    ) > -1
                  }
                />
              )}
          </div>
        ),
      },
      {
        dataIndex: "id",
        key: "id",
        title: "ID",
      },
      {
        dataIndex: "subject",
        key: "subject",
        title: this.props.i18n.t("Subject Code"),
        render: (val) => <span>{get(val, "code")}</span>,
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "subject" && sortedInfo.order,
      },
      {
        dataIndex: "created",
        key: "created",
        title: this.props.i18n.t("Generated Date"),
        render: (val) => (
          <span>
            {val ? `${moment.utc(val).format("YYYY-MM-DD")}` : "No data"}{" "}
          </span>
        ),
      },
      {
        dataIndex: "event_date",
        key: "event_date",
        title: this.props.i18n.t("Completed Date"),
        render: (val) => (
          <span>
            {val ? `${moment.utc(val).format("YYYY-MM-DD")}` : "No data"}{" "}
          </span>
        ),
      },
      {
        dataIndex: "site_id",
        key: "site_id",
        title: this.props.i18n.t("Site"),
        render: (val) =>
          get(
            find(sites, ({ id }) => id === val),
            "name"
          ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "site_id" && sortedInfo.order,
      },
      {
        dataIndex: "event",
        key: "event",
        title: this.props.i18n.t("Event Name"),
        sorter: true,
        render: (val) => <span>{get(val, "name")}</span>,
        sortOrder:
          get(sortedInfo, "columnKey") === "event" && sortedInfo.order,
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("Event Status"),
        render: (val, item) => (
          <span>{val === "cancelled" ? this.props.i18n.t("Invoice cancelled") : val} {get(item, "invoice_id") ? this.props.i18n.t(" (in invoice)") : ""}</span>
        ),
      },
      {
        dataIndex: "id",
        key: "event_status",
        title: this.props.i18n.t("Event Action"),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "event_status" && sortedInfo.order,
        render: (val, item) => (
          <div className={classes.actions}>
            <div>
              <b></b>
              <br />
              {!this.state.isFilterApprove ? <Tooltip placement="topLeft" title={this.props.i18n.t("Activate / Deactivate")}>
                <Switch
                  disabled={
                    (!item.event_status === "enabled" &&
                      !this.props
                        .financeInvoiceGeneratedEventUpdatePermission) ||
                    (item.event_status === "enabled" &&
                      !this.props.financeInvoiceGeneratedEventDeletePermission)
                  }
                  className={classes.activateBtn}
                  checked={item.event_status === "enabled"}
                  onChange={this.onSwitchStatus(
                    item.event_status === "enabled" ? "disabled" : "enabled",
                    item
                  )}
                />
              </Tooltip> : <div style={{ width: '44px', height: '22px'}}/>}
              <i>{get(item, "disabled_not_ready_for_billing") ? this.props.i18n.t(" (auto disabled because not billable)") : ""}</i>
            </div>
          </div>
        ),
      },
    ];

    const selectedBulkStatus = get(this.state.checkedItems[0], "id");

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">{this.props.i18n.t("Generated Events")}</h3>

            <div className={classes.searchWrapper}>
              <div className={classes.wrapperLocationFilter}>
                <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Filter by")}</b>
                <br />
                <div>
                  <Select
                    style={{ width: "200px" }}
                    onChange={this.handleFilterChange}
                    value={filtersBy[0]}
                  >
                    <Option value="site">{this.props.i18n.t("Site")}</Option>
                    <Option value="Event">{this.props.i18n.t("Event")}</Option>
                    <Option value="subject">{this.props.i18n.t("Subject")}</Option>
                  </Select>
                </div>
              </div>
              {filtersBy[0] === "Event" && (
                <div className={classes.wrapperLocationFilter}>
                  <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Filter by Event")}</b>
                  <br />
                  <div>
                    <Select
                      style={{ width: "300px" }}
                      onChange={this.onChangeGeneratedEventStatusFilter}
                      value={filtersValue[0]}
                    >
                      {eventList.map(({ name, id }) => (
                        <Option value={id} key={id}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              )}
              {filtersBy[0] === "site" && (
                <div className={classes.wrapperLocationFilter}>
                  <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Filter by sites")}</b>
                  <br />
                  <div>
                    <Select
                      style={{ width: "300px" }}
                      showSearch
                      optionFilterProp="children"
                      filterOption
                      onChange={this.onChangeGeneratedEventStatusFilter}
                      value={filtersValue[0]}
                    >
                      {sites
                        .sort((a, b) => a.code - b.code)
                        .filter((site) => site.site_type === "randomization")
                        .map(({ name, id, code }) => (
                          <Option value={id} key={id}>
                            {code} - {name}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              )}
              {filtersBy[0] === "subject" && (
                <div className={classes.wrapperLocationFilter}>
                  <b className={classes.searchWrapperLabel}>
                    {this.props.i18n.t("Filter by subject")}
                  </b>
                  <br />
                  <div>
                    <Input
                      style={{ width: "300px" }}
                      onChange={this.onChangeGeneratedEventTextFilter}
                      value={filtersValue[0]}
                    />
                  </div>
                </div>
              )}
              <div className={classes.wrapperLocationFilter}>
                <b className={classes.searchWrapperLabel}>{this.props.i18n.t("Select date range")}</b>
                <br />
                <div>
                  <RangePicker
                    value={filterDateRange}
                    onChange={this.onDateRangeChange}
                    format="DD MMM, YYYY"
                    allowClear={false}
                  />
                </div>
              </div>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            <div className={classes.wrapperFilters}>
              <div className={classes.searchWrapperFilterItemApprove}>
                <Checkbox
                  onChange={(e) =>
                    this.setState(
                      { isFilterApprove: e.target.checked, currentPage: 1 },
                      this.getGeneratedEvents
                    )
                  }
                  checked={isFilterApprove}
                >
                  {this.props.i18n.t("Send to invoice")}
                </Checkbox>
              </div>

              <div>
                <Button
                  type="primary"
                  htmlType="button"
                  loading={isClearingCache}
                  onClick={this.clearCache}
                >
                  {this.props.i18n.t("Refresh Events")}
                </Button>
              </div>
            </div>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <div className={classes.actionWrapper}>
              {selectedBulkStatus && (
                <div
                  style={{
                    position: "fixed",
                    padding: "1rem 3rem",
                    borderTop: "1px solid #eee",
                    boxShadow: "0 25px 50px 12px rgba(0,0,0,.25)",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    zIndex: 99,
                    background: "rgba(255,255,255,0.95)",
                  }}
                >
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <p style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
                      {this.props.i18n.t("Bulk Actions")}:{" "}
                      <span style={{ color: "#999" }}>
                        {this.state.checkedItems.length} {this.props.i18n.t("selected")}
                      </span>
                    </p>
                    <button
                      style={{
                        outline: "none",
                        cursor: "pointer",
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        border: "none",
                        color: "#aaa",
                      }}
                      onClick={() => this.setState({ checkedItems: [] })}
                    >
                      <Icon type="close" />
                    </button>
                  </div>
                  <div style={{ display: "flex" }}>
                    <Button
                      type="primary"
                      htmlType="button"
                      onClick={this.sentToInvoice}
                    >
                      {this.props.i18n.t("Send to invoice")}
                    </Button>
                  </div>
                </div>
              )}
            </div>

            <div style={{ position: "relative" }}>
              <Table
                columns={columns}
                dataSource={generatedEvents}
                rowKey="id"
                locale={{ emptyText: isLoading ? " " : undefined }}
                onChange={this.handleTableChange}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                  },
                  onChange: () => {
                    this.setState(() => ({ checkedItems: [] }));
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  position: 'both',
                }}
              />
              {isLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    zIndex: 50,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(255,255,255,0.9)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Icon
                    type="loading"
                    style={{ fontSize: "2rem", color: "#faa41a" }}
                  />
                </div>
              )}
            </div>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
  financeInvoiceGeneratedEventUpdatePermission: getFinanceInvoiceGeneratedEventUpdatePermission(
    state
  ),
  financeInvoiceGeneratedEventDeletePermission: getFinanceInvoiceGeneratedEventDeletePermission(
    state
  ),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FinanceGeneratedEvents))
);



// WEBPACK FOOTER //
// ./src/containers/FinanceGeneratedEvents/FinanceGeneratedEvents.js